"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onClientEntry = void 0;
const index_1 = __importDefault(require("../index"));
const recaptchaReady_1 = require("../recaptchaReady");
const recaptchaOnload = () => {
    recaptchaReady_1.recaptchaReady.ready();
    console.log("recaptcha ready");
};
const onClientEntry = (_, options) => {
    index_1.default.init(options);
    window.recaptchaOnload = recaptchaOnload;
    const apiEl = document.createElement("script");
    apiEl.id = "google-recaptcha-api";
    apiEl.src = `https://www.google.com/recaptcha/api.js?onload=recaptchaOnload&render=${options.explicit ? "explicit" : options.siteKey}`;
    apiEl.async = true;
    document.head.appendChild(apiEl);
    if (!options.explicit) {
        index_1.default.validate(options.siteAction).catch((err) => {
            console.error("Recaptcha failed validation:", err);
        });
    }
};
exports.onClientEntry = onClientEntry;
